<template>
    <BreadCrumb PageTitle="Update Task Type" />
    <UpdateTaskType />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import UpdateTaskType from "../../components/TaskTypes/UpdateTaskType.vue";
  
  export default defineComponent({
    name: "UpdateTaskTypePage",
    components: {
      BreadCrumb,
      UpdateTaskType,
    },
  });
  </script>